import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components/macro';
import { useSelector } from 'react-redux';
import { ResponseT } from '@utils/api/base';
import { RootState } from '../../store';
import useProducts from './useProducts';
import usePayments from './usePayments';
import { ProductL } from '../../type';
import useCognito from '@as_core/account/useCognito';

import { UserContext } from '@stores/UserContext';
import ProductCarousel from '@components/orders/components/ProductCarousel';
import OrdersCart from '@components/orders/components/OrdersCart';
import TextButton from '@components/controls/TextButton/TextButton';
import { FlexRow } from '@components/layout/FlexStyles';
import { ListLoader } from '@components/elements/listStyles';

const debug = false;
const OrderCreate = () => {
  const { getProducts } = useProducts();
  const products = useSelector((state: RootState) => state.products);
  const { getToken } = useCognito();
  const { createSession } = usePayments();
  const { user } = useContext(UserContext);
  debug && console.log(user);

  const [data, setData] = useState(null);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [ordersCart, setOrdersCart] = useState<any[]>([]);

  debug && console.log('productViews {views}', products);

  const loadData = React.useCallback(async () => {
    setIsDataLoading(true);
    let res: ResponseT<ProductL>;
    const params: { [propName: string]: any } = {
      // handle backwards compatibility with 3RnD using 'commercial'
      type: user.regInfo.organization.type === 'commercial' ? 'corporate' : user.regInfo.organization.type,
    };
    res = await getProducts(getToken(), params);

    setData(res);
    setIsDataLoading(false);
    // setLoadedAll(!res.continues);
  }, []);

  useEffect(() => {
    if (products && isDataLoading === false) {
      loadData().then();
    }
  }, [products, loadData]);

  const getProductHash = (itemId: string) => {
    return data.productList.find((item) => itemId === item.catalogNumber).hash;
  };

  const sendForm = async (model) => {
    let resp;
    try {
      resp = await createSession(model);
      if (resp.status === 'OK') {
        window.open(resp.url, '_self');
      } else if (resp.status === 'Error') {
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = (e) => {
    const items = Object.entries(ordersCart).map(([key, value]) => ({
      productId: getProductHash(key),
      quantity: value,
    }));
    e.preventDefault();
    const model = {
      items: items,
      customer: {
        firstName: user.regInfo.name.first,
        lastName: user.regInfo.name.last,
        companyName: user.regInfo.organization.name,
        address: user.regInfo.address.address,
        postalCode: user.regInfo.address.postalCode,
        city: user.regInfo.address.city,
        state: user.regInfo.address.state,
        country: user.regInfo.address.country,
        email: user.regInfo.email,
      },
    };
    sendForm(model).then();
  };

  const handleAddToCart = (item: string, quantity: number) => {
    debug && console.log('OrderCreate | handleAddToCart', item, quantity);
    let currentQuantity = Object.hasOwn(ordersCart, item)
      ? ordersCart[item]
      : 0;
    setOrdersCart((prev) => ({ ...prev, [item]: currentQuantity + quantity }));
  };
  debug && console.log('data', data, 'orders', ordersCart);

  return (
    <>
      {isDataLoading ? (
        <FlexRow width={'100%'} height={'200px'} v_centered h_centered>
          <ListLoader />
        </FlexRow>
      ) : (
        <>
          <ProductCarousel
            products={data?.productList}
            onAddToCart={handleAddToCart}
          />
          <OrdersCart
            products={data?.productList}
            cart={ordersCart}
            updateCart={setOrdersCart}
          />
          {Object.keys(ordersCart).length > 0 ? (
            <OrdersButton>
              <TextButton
                width={200}
                label={'Proceed to Order Purchase'}
                onClick={handleSubmit}
              />
            </OrdersButton>
          ) : null}
        </>
      )}
    </>
  );
};

export default OrderCreate;

const OrdersButton = styled.div`
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
`;
